import * as hairTextures from 'constants/hairTextures';

import { ReactComponent as Type1 } from 'assets/images/consultation/scoringLoadingScreens/type_1.svg';
import { ReactComponent as Type2 } from 'assets/images/consultation/scoringLoadingScreens/type_2.svg';
import { ReactComponent as Type3a } from 'assets/images/consultation/scoringLoadingScreens/type_3a.svg';
import { ReactComponent as Type3b } from 'assets/images/consultation/scoringLoadingScreens/type_3b.svg';
import { ReactComponent as Type3c } from 'assets/images/consultation/scoringLoadingScreens/type_3c.svg';
import { ReactComponent as Type4a } from 'assets/images/consultation/scoringLoadingScreens/type_4a.svg';
import { ReactComponent as Type4b } from 'assets/images/consultation/scoringLoadingScreens/type_4b.svg';
import { ReactComponent as Type4c } from 'assets/images/consultation/scoringLoadingScreens/type_4c.svg';

export const skincareLoadingContent = {
  disclaimer:
    '*Real testimonials from people who received free products in exchange for their feedback',
  title: 'We’re analyzing your answers...',
  description:
    'See what other customers with your concerns are saying about their custom formulas.*',
  reviews: [
    {
      displayName: '- Adrian V',
      comment:
        '"I loved all of it. I noticed an improvement at first use and have been very pleased. This is the first time in my life where I have been able to go makeup free!"',
    },
    {
      displayName: '- Flip M',
      comment:
        '"I’ve noticed fine lines are diminishing. Love that my skin doesn’t feel dry/flaky in some spots and oily in others. Instead my skin feels well nourished and smooth."',
    },
  ],
};

const threeBContent = {
  Icon: Type3b,
  textureLabel: 'very curly hair',
  reviews: [
    {
      rating: 5,
      comment:
        '“I have very thick, colored hair and getting it moisturized without too much oil was hard. These products really are customized to fit your specific needs and work very well.”',
      displayName: '–Kristy C.',
    },
    {
      rating: 4,
      comment:
        '“My curls loved this product. After seeing my curls bounce, even my boyfriend stole a couple pumps :)”',
      displayName: '–Ceyd P.',
    },
  ],
};

export const variantAContent = {
  title: name => `${name}, we’re analyzing your answers…`,
  description: textureLabel => (
    <>
      See what other customers with{' '}
      <span className="scoring-loading-description-span">{textureLabel}</span> are saying about
      their custom formulas*
    </>
  ),
  disclaimer: '*Individual results may vary',
  [hairTextures.ONE]: {
    Icon: Type1,
    textureLabel: 'straight hair',
    reviews: [
      {
        rating: 5,
        comment:
          '“My hair has much more volume and doesn’t need to be washed frequently, lasting several days between washes.”',
        displayName: '–Pietra B.',
      },
      {
        rating: 4,
        comment:
          '“I have very fine hair that tangles a lot. With Prose, I can brush right through my hair without a problem and my hair is shinier than it’s ever been.”',
        displayName: '–Rachel B.',
      },
    ],
  },
  [hairTextures.WAVY]: {
    Icon: Type2,
    textureLabel: 'wavy hair',
    reviews: [
      {
        rating: 5,
        comment:
          '“After trying these products, I LOVE my hair!! It is shiny, bouncy and less frizzy. My coworkers have noticed how my hair now had defined curls.”',
        displayName: '–Starla D.',
      },
      {
        rating: 4,
        comment:
          '“Before trying Prose I was ready to chop off all the hair. It’s so so much better now. Less greasy, less flaky, I love it!”',
        displayName: '–Katherine S.',
      },
    ],
  },
  [hairTextures.TWO_A]: {
    Icon: Type2,
    textureLabel: 'wavy hair',
    reviews: [
      {
        rating: 5,
        comment:
          '“After trying these products, I LOVE my hair!! It is shiny, bouncy and less frizzy. My coworkers have noticed how my hair now had defined curls.”',
        displayName: '–Starla D.',
      },
      {
        rating: 4,
        comment:
          '“Before trying Prose I was ready to chop off all the hair. It’s so so much better now. Less greasy, less flaky, I love it!”',
        displayName: '–Katherine S.',
      },
    ],
  },
  [hairTextures.TWO_B]: {
    Icon: Type2,
    textureLabel: 'wavy hair',
    reviews: [
      {
        rating: 5,
        comment:
          '“After trying these products, I LOVE my hair!! It is shiny, bouncy and less frizzy. My coworkers have noticed how my hair now had defined curls.”',
        displayName: '–Starla D.',
      },
      {
        rating: 4,
        comment:
          '“Before trying Prose I was ready to chop off all the hair. It’s so so much better now. Less greasy, less flaky, I love it!”',
        displayName: '–Katherine S.',
      },
    ],
  },
  [hairTextures.TWO_C]: {
    Icon: Type2,
    textureLabel: 'wavy hair',
    reviews: [
      {
        rating: 5,
        comment:
          '“After trying these products, I LOVE my hair!! It is shiny, bouncy and less frizzy. My coworkers have noticed how my hair now had defined curls.”',
        displayName: '–Starla D.',
      },
      {
        rating: 4,
        comment:
          '“Before trying Prose I was ready to chop off all the hair. It’s so so much better now. Less greasy, less flaky, I love it!”',
        displayName: '–Katherine S.',
      },
    ],
  },
  [hairTextures.THREE_A]: {
    Icon: Type3a,
    textureLabel: 'curly hair',
    reviews: [
      {
        rating: 5,
        comment:
          '“Finally got the curly girl method curls that I’ve been wanting. Smells great and leaves my hair so much more manageable.”',
        displayName: '–Maya F.',
      },
      {
        rating: 4,
        comment:
          '"My naturally curly hair has always been dry, frizzy, and dull, but even my friends have commented on how soft and shiny my hair is... immediately after the first use!”',
        displayName: '–Melissa G.',
      },
    ],
  },
  [hairTextures.DEPRECATED_CURLY]: threeBContent,
  [hairTextures.THREE_B]: threeBContent,
  [hairTextures.THREE_C]: {
    Icon: Type3c,
    textureLabel: 'tight curls',
    reviews: [
      {
        rating: 5,
        comment:
          '“My curls have never looked better! I figured I’d give Prose a try and expected the same old same old. A-MAZE-ING!!! I won’t be using anything else from now on.”',
        displayName: '–Jennifer P.',
      },
      {
        rating: 4,
        comment:
          '“As I get older my hair was not responding to professional products anymore. I was really concerned I could not get back to soft defined curls but Prose has done it!”',
        displayName: '–Lori F.',
      },
    ],
  },
  [hairTextures.VERY_CURLY]: {
    Icon: Type4a,
    textureLabel: 'coily hair',
    reviews: [
      {
        rating: 5,
        comment:
          '“My hair was so dry and lost its curl. It was only a few weeks after Prose I saw a huge difference! I’m back to coils like when I was in kindergarten!”',
        displayName: '–Megan C.',
      },
      {
        rating: 4,
        comment:
          '“I did not know it would be this easy to manage my hair until I started using Prose. It}s no longer a daunting task to wash and style it.”',
        displayName: '–Arie A.',
      },
    ],
  },
  [hairTextures.FRIZZY]: {
    Icon: Type4b,
    textureLabel: 'zig-zag coils',
    reviews: [
      {
        rating: 5,
        comment:
          '“I have super frizzy hair. After only one use, my ends looked as though they’d been freshly cut. My hair looks shiny and healthier than it ever has.”',
        displayName: '–Carlie F.',
      },
      {
        rating: 4,
        comment:
          '“Prose has really helped me to balance my scalp health. I was suffering with a dry, flaky, itchy scalp. It’s almost 100% better now.”',
        displayName: '–Raiysa A.',
      },
    ],
  },
  [hairTextures.ZIGZAG]: {
    Icon: Type4c,
    textureLabel: 'tight zig-zag hair',
    reviews: [
      {
        rating: 5,
        comment:
          '“I have finally found what I have been looking for with Prose. My hair feels softer, healthier, shiny and manageable. I can let my curls go natural and love my curls.”',
        displayName: '–Cherie U.',
      },
      {
        rating: 4,
        comment:
          '“I love Prose, it has really helped heal my scalp issues. I have sisterlocks, so my locs always feel clean and my scalp moisturized.”',
        displayName: '–Jai T.',
      },
    ],
  },
};
